export const customRequestSkillsNumber = 15;